import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Pantalla mostrada al usuario cuyo `must_change_password=true`
 * (típicamente tras reset por email con contraseña temporal).
 * Bloquea el resto del shell hasta que defina una nueva contraseña.
 */
export default function ChangePassword() {
    const navigate = useNavigate();
    const { user, refreshUser } = useAuth();
    const [oldPw, setOldPw] = useState("");
    const [newPw, setNewPw] = useState("");
    const [confirmPw, setConfirmPw] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const forced = !!user?.must_change_password;

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        if (newPw.length < 8) { setError("La nueva contraseña debe tener al menos 8 caracteres."); return; }
        if (newPw !== confirmPw) { setError("Las contraseñas no coinciden."); return; }
        setLoading(true);
        try {
            await api.post("/auth/change-password", { current_password: oldPw, new_password: newPw });
            await refreshUser();
            navigate("/dashboard", { replace: true });
        } catch (err) {
            setError(formatApiError(err, "No pudimos actualizar tu contraseña"));
        } finally { setLoading(false); }
    };

    return (
        <div className="auth-shell" data-testid="change-password-page">
            <section className="auth-hero">
                <div className="brand">itotal<span className="accent">4u</span></div>
                <div>
                    <h2>{forced ? "Define tu nueva contraseña" : "Cambiar contraseña"}</h2>
                    <p className="tag">
                        {forced
                            ? "Usaste una contraseña temporal. Antes de continuar, define una contraseña personal segura."
                            : "Actualiza tu contraseña ingresando la actual y una nueva."}
                    </p>
                </div>
                {forced && (
                    <div className="meta" data-testid="change-pwd-forced-banner" style={{ borderColor: "#DC2626", background: "rgba(220,38,38,0.08)" }}>
                        ⚠️ Cambio obligatorio
                    </div>
                )}
            </section>
            <section className="auth-pane">
                <div className="auth-card">
                    <h3>{forced ? "Cambio de contraseña obligatorio" : "Cambiar contraseña"}</h3>
                    {error && <div className="alert alert-error" data-testid="change-pwd-error">{error}</div>}

                    <form onSubmit={submit} className="row" style={{ gap: 14 }}>
                        <div className="field">
                            <label>{forced ? "Contraseña temporal (la del correo)" : "Contraseña actual"}</label>
                            <input type="password" className="input" value={oldPw} onChange={(e) => setOldPw(e.target.value)} required data-testid="change-pwd-old" autoFocus />
                        </div>
                        <div className="field">
                            <label>Nueva contraseña</label>
                            <input type="password" className="input" value={newPw} onChange={(e) => setNewPw(e.target.value)} required minLength={8} data-testid="change-pwd-new" />
                        </div>
                        <div className="field">
                            <label>Confirmar nueva contraseña</label>
                            <input type="password" className="input" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} required minLength={8} data-testid="change-pwd-confirm" />
                        </div>
                        <button className="btn btn-primary btn-block" type="submit" disabled={loading} data-testid="change-pwd-submit">
                            {loading ? <span className="loader" /> : "Actualizar contraseña"}
                        </button>
                    </form>
                </div>
            </section>
        </div>
    );
}
